import { useState, useEffect } from 'react';
import { API } from '../App';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Trophy, Zap, Star, Target, Award, CheckCircle, Lock } from 'lucide-react';

const iconMap = {
  'zap': Zap, 'trophy': Trophy, 'star': Star, 'target': Target,
  'award': Award, 'check-circle': CheckCircle, 'piggy-bank': Target
};

export default function Gamification() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gamification`, { withCredentials: true }).then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const pct = Math.min(100, (data.xp_in_level / data.xp_to_next) * 100);

  return (
    <Card className="bg-[#1a2332] border-[#2a3444]" data-testid="gamification-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-white text-base" style={{ fontFamily: 'Playfair Display, serif' }}>
          <Trophy className="w-5 h-5 text-[#D4AF37]" />
          Nivel & Logros
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Level Bar */}
        <div>
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm text-white font-medium">Nivel {data.level}</span>
            <span className="text-xs text-gray-500">{data.xp_in_level}/{data.xp_to_next} XP</span>
          </div>
          <div className="w-full h-2 bg-[#141b2d] rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#D4AF37] to-[#f0d060] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
          <p className="text-[10px] text-gray-600 mt-1">{data.xp} XP total</p>
        </div>

        {/* Badges */}
        <div className="grid grid-cols-4 gap-2">
          {data.badges.slice(0, 8).map(b => {
            const Icon = iconMap[b.icon] || Star;
            return (
              <div key={b.id + (b.unlocked ? '_u' : '_l')} className={`flex flex-col items-center gap-1 p-2 rounded-lg border text-center ${
                b.unlocked ? 'bg-[#D4AF37]/10 border-[#D4AF37]/30' : 'bg-[#141b2d] border-[#2a3444] opacity-50'
              }`} title={b.name}>
                {b.unlocked ? <Icon className="w-5 h-5 text-[#D4AF37]" /> : <Lock className="w-5 h-5 text-gray-600" />}
                <span className="text-[9px] text-gray-400 leading-tight">{b.name}</span>
                {b.progress && <span className="text-[8px] text-gray-600">{b.progress}</span>}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
